import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import listenForAuthChanges from './ViewModels/checkAuth';
import store from './Redux/store';
import { Provider } from 'react-redux';

listenForAuthChanges(store.dispatch)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>
);
